module.exports = __webpack_public_path__ + "static/assets/0960bb1c4cf12a924f2bc74325583fea.gif";